import { UploadOutlined } from '@ant-design/icons';
import { Button, Col, message, Row } from 'antd';
import React, { ChangeEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ALLOWED_FILES, FILE_SIZE_ALLOWED } from 'src/constants';
import { uniqueKey } from 'src/helpers/string.utils';
import { IFileGuarantor } from 'src/interfaces/mortgage-deal/invite-guarantor';
import { i18nKey } from 'src/locales/i18n';
import styles from './upload-file-guarantor.module.less';

interface IProps {
	inputFile?: IFileGuarantor;
	accept?: string[];
	allowSize?: number;
	onChange?: (file: File) => void;
	disableUploadButton?: boolean;
}

const UploadFileGuarantor = ({
	inputFile,
	accept = DEFAULT_ALLOWED_FILES,
	allowSize = FILE_SIZE_ALLOWED.SINGLE,
	disableUploadButton,
	onChange
}: IProps) => {
	const rFile = useRef<HTMLInputElement>(null);

	const [t] = useTranslation();

	const onFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
		if (!e.target.files || !e.target.files.length) {
			return;
		}

		const file = e.target.files[0];
		if (file.size > allowSize) {
			message.error(t(i18nKey.feedback.maxFileSizeReached));
			e.target.value = '';
			return;
		}
		onChange && onChange(file);
		e.target.value = '';
	};

	const onUploadClick = () => {
		rFile.current && rFile.current.click();
	};

	return (
		<>
			<Row>
				<Col span={19}>
					<div key={uniqueKey(16)} className={styles.fileInputContainer}>
						<div className={styles.fileName}>{inputFile?.fileName || '-'}</div>
					</div>
				</Col>
				<Col span={5}>
					{!disableUploadButton && (
						<>
							<Button
								type="primary"
								icon={
									<UploadOutlined
										style={{
											color: '#FFF',
											fontWeight: 800,
											fontSize: '2.3rem'
										}}
									/>
								}
								onClick={onUploadClick}></Button>
						</>
					)}
				</Col>
				<input
					ref={rFile}
					type="file"
					onChange={onFileChange}
					hidden
					max={1}
					accept={`${accept ? accept.join(',') : '*'}`}
				/>
			</Row>
		</>
	);
};

export default UploadFileGuarantor;
